import type { QueryClient } from '@tanstack/react-query';
import type { useGT } from 'gt-react';
import type { GetSuggestionDetailResponse } from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';
import type { OverrideSectionSubmitArgs } from './runOverrideSectionSubmit';
import type { OverrideEffectiveState } from './overrideSectionDerivedState';

type Gt = ReturnType<typeof useGT>;

export function buildOverrideSectionSubmitArgs({
  queryClient,
  gt,
  suggestion,
  bulkLineCount,
  linesForBulk,
  effective,
  overrideMutateAsync,
}: {
  queryClient: QueryClient;
  gt: Gt;
  suggestion: GetSuggestionDetailResponse;
  bulkLineCount: number;
  linesForBulk: OverrideSectionSubmitArgs['linesForBulk'];
  effective: OverrideEffectiveState;
  overrideMutateAsync: OverrideSectionSubmitArgs['overrideMutateAsync'];
}): OverrideSectionSubmitArgs {
  return {
    queryClient,
    gt,
    suggestion,
    bulkLineCount,
    linesForBulk,
    form: {
      action: effective.effectiveAction,
      quantity: effective.qty,
      applyQuantityToAllLines: effective.applyQuantityToAllLines,
      vendorId: effective.effectiveVendorId,
      sourceId: effective.effectiveSourceId,
    },
    overrideMutateAsync,
    isBuy: effective.isBuy,
    isTransfer: effective.isTransfer,
    effectiveAction: effective.effectiveAction,
    effectiveVendorId: effective.effectiveVendorId,
    effectiveSourceId: effective.effectiveSourceId,
    qty: effective.qty,
    vendor: effective.selectedVendor,
  };
}
